import { FC } from 'react';
import { Typography } from '@mui/material';
import { FormatQuote } from '@mui/icons-material';
import { Stack } from '@mui/system';
import { useTheme } from '@mui/material/styles';

type Props = {
	value?: string | null;
};

export const PersonaDetailQuote: FC<Props> = ({ value }) => {
	const theme = useTheme();

	return value ? (
		<Stack alignItems={'center'} gap={1}>
			<FormatQuote sx={{ color: theme.palette.grey[400] }} />
			<Typography variant={'h2'} fontSize={'18px'} fontWeight={'700'} textAlign={'center'}>
				{value}
			</Typography>
		</Stack>
	) : null;
};
